import { render, staticRenderFns } from "./editmyprofile.vue?vue&type=template&id=115ebaf9&"
import script from "./editmyprofile.vue?vue&type=script&lang=js&"
export * from "./editmyprofile.vue?vue&type=script&lang=js&"
import style0 from "./editmyprofile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports